import { FC, useState } from 'react';
import { DetailRow } from './profileDetailsRow.styles';
import { TextInputField, AutocompleteField } from '@sainsburys-tech/luna-react';
import { DropDownOptions, getDefaultOption } from 'src/utils/createOptions';
import { UseFormReturn, Controller, FieldValues } from 'react-hook-form';
import { Drawer } from '@mui/material';
import { ViewAdDetailsScreen } from '../profileCard/screens/viewAdDetailsScreen';


enum PanelAction {
  VIEW_AD_DETAILS = 'VIEW_AD_DETAILS',
}
interface IProfileDetailRow {
  label: string;
  value: string;
  name: string;
  isEditable?: boolean;
  dropDownData?: DropDownOptions[];
  formObj?: UseFormReturn<FieldValues, any>;
  cssClass?: string;
  children?: React.ReactNode;
  isClickable?: boolean;
  setShowSidePanel?: (status: PanelAction | null) => void;
}


export const ProfileDetailRow: FC<IProfileDetailRow> = ({
  label,
  value,
  name,
  isEditable = false,
  dropDownData,
  formObj,
  cssClass,
  children,
  isClickable,
  setShowSidePanel,
}) => {
  const renderInputOptions = () => {
    const { formState, control, setValue, getValues, trigger } = formObj || {};
    const { errors } = formState || {};

    const defaultOption = dropDownData && getDefaultOption(dropDownData, value);

    return (
      <>
        {dropDownData ? (
          <Controller
            name={name}
            control={control}
            render={({ field }) => (
              <AutocompleteField
                {...field}
                error={errors && errors[name]?.message}
                label={label}
                options={dropDownData}
                defaultSelectedOption={defaultOption}
                placeholder={label}
                onSelect={async (selected: any) => {
                  setValue && setValue(name, selected?.value || '');
                  selected && trigger && (await trigger(name));
                }}
                hideLabel
              />
            )}
          />
        ) : (
          <Controller
            name={name}
            control={control}
            defaultValue={value}
            render={({ field }) => (
              <TextInputField
                {...field}
                onChange={field.onChange}
                error={errors && errors[name]?.message}
                label={label}
                hideLabel
              />
            )}
          />
        )}
      </>
    );
  };
  return (
    <>
      <DetailRow className={cssClass}>
        <div className='label'>{label}</div>
        <div className={'value'}>
          {isEditable && formObj ? (
            renderInputOptions()
          ) : isClickable && value !== 'UNAVAILABLE' ? (
            <span
              className='underlined'
              onClick={() =>
                setShowSidePanel &&
                setShowSidePanel(PanelAction.VIEW_AD_DETAILS)
              }
            >
              {value}
            </span>
          ) : (
            <>{value}</>
          )}
          {children}
        </div>
      </DetailRow>
    </>
  );
};
